export enum MENU_TYPE {
    ANNOUNCEMENT = "ประกาศ", // i18n-ignore: enum value (tab id), translated at render site
    EXAM_BOOKING = "จองวันสอบ", // i18n-ignore: enum value (tab id), translated at render site
}
